<template>
	<div class="olb-map-info-window">
		<address class="olb-address">
			<span class="font-bold">
				{{ name }}
			</span>
			<span><slot name="street"></slot></span>
			<span>{{ zip }} {{ city }}</span>
			<a v-if="url" class="olb-link" :href="url">
				<span>Zur Filiale</span>
				<span class="olb-icon olb-icon-arrow-nav-right text-icon-sm ml-2 self-baseline"></span>
			</a>
		</address>
	</div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		name: String,
		street: String,
		zip: String,
		city: String,
		url: String,
	},
});
</script>
